module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"search":"Search","tabs":["Library","Search"]}}')
  delete Component.options._Ctor
}
